<template>
  <b-card no-body>
    <div style="display: inline-flex; align-items: center;">
      <div style="flex: 0 1 auto;">
        <img v-if="['US', 'CA'].includes(countryCode)" src="@/assets/home/truck.jpg" />
        <img width="174" v-else-if="['AR', 'CL', 'CO', 'EC'].includes(countryCode)" src="@/assets/home/cylinders.jpg" />
        <img v-else-if="company === 'Indura'" src="@/assets/home/indura.png" />
        <img v-else-if="company === 'Cryogas'" src="@/assets/home/cryogas.png" />
        <img v-else src="@/assets/home/cylinders.jpg" />
      </div>

      <div style="flex: 1 1 auto; padding-left: 50px;">
        <p class="ap-green mb-0">
          <span v-if="['US', 'CA'].includes(countryCode)" v-html="$t('ml_107025', { company: company })">
            x-Save time online... with your account management system.
          </span>
          <span v-else v-html="$t('ml_107026', { company: company })">
            x-Everything you need to manage your Industrial Gases online
          </span>
        </p>
      </div>
    </div>
  </b-card>
</template>

<script>
export default {
  name: 'Banner',
  props: {
    countryCode: {
      type: String,
      default: null
    },
    company: {
      type: String,
      default: 'AirProducts'
    }
  }
}
</script>
